var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 73,
    viewBox: "0 0 100 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6196 29.6072V26.084",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7471 26.084V29.6072",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8755 16.2645C36.6025 13.6055 37.1596 10.9271 38.4701 8.59732C39.7806 6.26756 41.7803 4.40073 44.1945 3.25324C46.6087 2.10575 49.319 1.73391 51.9531 2.1888C54.5871 2.64369 57.0158 3.903 58.9053 5.79372C60.7948 7.68445 62.0526 10.1139 62.5058 12.7482C62.9591 15.3825 62.5855 18.0926 61.4365 20.5061C60.2875 22.9196 58.4194 24.9181 56.0888 26.2272C53.7582 27.5362 51.0795 28.0915 48.4206 27.8169C45.4617 27.5112 42.6985 26.1957 40.5958 24.0917C38.4931 21.9876 37.1793 19.2236 36.8755 16.2645V16.2645Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8745 29.4316L49.7452 40.1032L43.6597 29.4316H40.6752C37.2136 29.4316 33.8938 30.8068 31.4461 33.2545C28.9984 35.7022 27.6233 39.0219 27.6233 42.4835V71.3388H65.8617",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2729 29.4316H57.2575C60.719 29.4316 64.0388 30.8068 66.4865 33.2545C68.9342 35.7022 70.3093 39.0219 70.3093 42.4835V71.3388H61.676",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2202 71.4424V43.8027",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2366 25.6257V22.8086",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7297 22.8086V25.6257",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2266 14.9401C71.0079 12.8104 71.4541 10.6652 72.5037 8.79928C73.5534 6.93334 75.155 5.43816 77.0887 4.51918C79.0223 3.6002 81.1931 3.30248 83.3028 3.66693C85.4124 4.03139 87.3575 5.04014 88.8708 6.55459C90.384 8.06904 91.3912 10.0149 91.754 12.1249C92.1168 14.2348 91.8174 16.4053 90.8969 18.3383C89.9764 20.2712 88.48 21.8717 86.6132 22.9199C84.7464 23.9681 82.6009 24.4125 80.4714 24.1922C78.1019 23.947 75.8893 22.8933 74.2056 21.2083C72.5219 19.5232 71.4699 17.3097 71.2266 14.9401V14.9401Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7024 59.0527H94.4403",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4406 25.4863L81.5125 34.0323L76.6062 25.4863H74.2331C72.7043 25.489 71.1947 25.8274 69.811 26.4777C68.4274 27.128 67.2035 28.0743 66.2258 29.2497C65.6007 30.0056 65.0815 30.8432 64.6826 31.7393",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1519 25.4863H87.5395C90.3125 25.4863 92.972 26.5874 94.9335 28.5475C96.895 30.5077 97.998 33.1664 97.9999 35.9395V59.0514H91.0773",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4568 25.655V22.8379",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 22.8379V25.655",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44687 14.9702C9.22808 12.8408 9.67393 10.6958 10.7232 8.82996C11.7724 6.9641 13.3735 5.46882 15.3067 4.54951C17.2399 3.63019 19.4103 3.33193 21.5198 3.69568C23.6293 4.05943 25.5744 5.06735 27.0881 6.581C28.6017 8.09466 29.6097 10.0398 29.9734 12.1493C30.3372 14.2588 30.0389 16.4292 29.1196 18.3624C28.2003 20.2956 26.705 21.8967 24.8391 22.946C22.9733 23.9952 20.8284 24.441 18.6989 24.2222C16.3287 23.9773 14.1151 22.9239 12.4301 21.2389C10.7452 19.554 9.69177 17.3404 9.44687 14.9702Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6606 25.5176L19.7543 34.0999L14.848 25.554H12.4604C11.0871 25.553 9.727 25.8227 8.45793 26.3476C7.18886 26.8725 6.03566 27.6423 5.06422 28.6131C4.09279 29.5838 3.32218 30.7365 2.7964 32.0052C2.27063 33.2739 2 34.6338 2 36.0071V59.119H27.5869",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3796 25.5176H25.7672C27.7485 25.5161 29.6895 26.0769 31.3647 27.1348C33.0398 28.1927 34.3803 29.7043 35.2304 31.4939",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91528 59.1619V37.0254",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5742 70.8528V43.8027",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.08c8ea0f.svg";
export { ForwardRef as ReactComponent };